import { useState } from "react";
import PersonalInformationDynamic from "./PersonalInformationDynamic";
export interface TypeAndSpecialization {
  desc: string;
  id: number;
  name: string;
  multipleAllowed: boolean;
}
export const SideMenuPersonalInformation = ({
  selectedMenu,
  setSelectedMenu,
  capturedImage,
  setCapturedImage,
  jsonObjForRenderingUi,
  setSegmentOrder,
  onClickToNextPage,
  validateForm,
  requiredFieldsWithPattern,
  order,
  onClickToPreviousPage,
}: any) => {
  const [capturedFileImage, setCapturedFileImage] = useState<File | undefined>(
    undefined
  );
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [showBankDetailsWithMaskedData, setShowBankDetailsWithMaskedData] =
  useState(true);
  const [selectedSpecializationList, setSelectedSpecializationList] = useState<
  TypeAndSpecialization[] | null
>(null);
  return (
    <PersonalInformationDynamic
      selectedMenu={selectedMenu}
      setSelectedMenu={setSelectedMenu}
      setSegmentOrder={setSegmentOrder}
      jsonobj={jsonObjForRenderingUi}
      capturedImage={capturedImage}
      capturedFileImage={capturedFileImage}
      setCapturedFileImage={setCapturedFileImage}
      setCapturedImage={setCapturedImage}
      order={order}
      onClickToNextPage={onClickToNextPage}
      validateForm={validateForm}
      requiredFieldsWithPattern={requiredFieldsWithPattern}
      onClickToPreviousPage={onClickToPreviousPage}
      errors={errors}
      setErrors={setErrors}
      handelPreviousButtonClick={onClickToPreviousPage}
      setShowBankDetailsWithMaskedData={setShowBankDetailsWithMaskedData}
      showBankDetailsWithMaskedData={showBankDetailsWithMaskedData}
      setSelectedSpecializationList={setSelectedSpecializationList}
      selectedSpecializationList={selectedSpecializationList}
    />
  );
};
